<template>
  <div id="app">
    <comheader></comheader>
    <div class="lf ks_right" id="rmodel">
      <comtop></comtop>

      <el-main>
        <div class="com_topaside">
          <span>培训<b>></b></span>
          <span>考试管理<b>></b></span>
          <span>试题管理<b></b></span>
        </div>
        <div class="com_typography">
          <el-input
            placeholder="请输入内容"
            v-model="input"
            class="com_search lf"
            @change="searchtxt"
            ><i slot="prefix" class="el-input__icon el-icon-search"></i
          ></el-input>
          <el-button
            type="primary"
            class="add_exam"
            icon="el-icon-plus"
            @click="dialogAdditem(1)"
            >新建题库</el-button
          >
          <el-checkbox
            v-model="checked"
            class="rf com_checked"
            @change="chageMe"
            >只看我创建的</el-checkbox
          >
          <el-cascader
            v-model="cascaderVal"
            ref="cascader"
            :options="options"
            class="rf cascaderV"
            :props="{ value: 'name', label: 'name', children: 'son' }"
            :show-all-levels="false"
            @change="cascaderOp"
            clearable
          ></el-cascader>
        </div>
      </el-main>
      <el-main class="exam_wrap">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="exam_table exam_btnManeger"
        >
          <el-table-column
            v-for="info in tableHeadr"
            :key="info.key"
            :property="info.key"
            :label="info.label"
            :width="info.width"
          >
            <template slot-scope="scope">
              {{ scope.row[scope.column.property] }}
              <!-- 渲染对应表格里面的内容 -->
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope" class="exam_btn">
              <el-button
                type="text"
                size="large"
                @click="dialogAdditem(2, scope)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="large"
                @click="del(scope.$index, scope.row.e_id)"
                class="exam_delbtn"
                >删除</el-button
              >
              <el-button
                @click="hrefto(scope.row.e_id)"
                type="text"
                size="large"
                >管理试题</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <page :count="count" :curpage.sync="page" @pagenation="pagetion"></page>
      </el-main>
      <el-dialog
        :title="editExam == 1 ? '新建题库' : '编辑题库'"
        :visible.sync="dialogAdd"
        custom-class="dialogAdditem"
      >
        <el-form
          :model="addForm"
          :rules="rules"
          ref="addForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="所属分类：" prop="view" class="AddSelect">
            <el-select v-model="addForm.region">
              <el-option :value="addForm.region" style="height: 0"></el-option>
              <el-tree
                :data="viewList"
                :props="defaultProps"
                @node-click="nodeclick"
                ref="tree"
                node-key="id"
              ></el-tree>
            </el-select>
          </el-form-item>
          <el-form-item label="题库名称：" prop="title" class="AddInput">
            <el-input v-model="addForm.title" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="可见范围：" prop="title" class="AddRadio">
            <el-radio v-model="addForm.radio" label="1">全员</el-radio>
            <!-- <el-radio v-model="addForm.radio" label="2" >部门/学员</el-radio>
                <el-radio v-model="addForm.radio" label="3">仅自己可见</el-radio> -->
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="validateForm(editExam)"
            >保存</el-button
          >
          <el-button type="primary" @click="dialogAdd = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <dialogFw
      :visible.sync="visible"
      :bmid.sync="bmid"
      @bmidfw="bmidfwtxt"
    ></dialogFw>
  </div>
</template>

<script>
//

import comheader from "./Common/comheader";
import comtop from "./Common/comtop";
import page from "./Common/page";
import dialogFw from "./Common/dialog";
import { checkindex } from "../https/index";

export default {
  inject: ["reload"],
  name: "index",
  data() {
    return {
      oppp: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      opv: "",
      show: true,
      dialogAdd: false,
      visible: false,
      input: "",
      regiid: "",
      checked: "",
      url: this.HOME,
      cateid: "",
      raido: "0",
      cascaderVal: "",
      limit: 10, //一页几条数据
      count: 0, //数据总计
      bmid: 0,
      page: 1, //当前页数
      radiobmid: "",
      editExam: 1,
      editEid: "",
      viewList: [],
      options: [],
      addForm: {
        view: "",
        title: "",
        region: "",
        radio: "",
        type: "",
      },
      rules: {
        region: { required: true, message: "请选择分类", trigger: "change" },
        title: { required: true, message: "请输入题库名称", trigger: "blur" },
      },
      tableData: [],
      tableHeadr: [
        {
          label: "题库名称",
          key: "model_name",
          width: "470",
        },
        {
          label: "所属分类",
          key: "name",
          width: "222",
        },
        {
          label: "创建人",
          key: "create_name",
          width: "104",
        },
        {
          label: "单选题",
          key: "dan",
          width: "105",
        },
        {
          label: "多选题",
          key: "duo",
          width: "108",
        },
        {
          label: "判断题",
          key: "judge",
          width: "108",
        },
        {
          label: "填空题",
          key: "fill",
          width: "108",
        },
        // {
        // label:'简答题',
        // key:'ans',
        // width:'105'

        // },
      ],
      defaultProps: {
        children: "son",
        label: "name",
      },
      nowType: "",
      typeList: [
        {
          name: "全部",
          id: 0,
        },
        {
          name: "考试系统",
          id: 1,
        },
        {
          name: "分享课",
          id: 2,
        },
      ],
    };
  },
  components: {
    comheader,
    comtop,
    page,
    dialogFw,
  },
  methods: {
    tabIndex(target, nodeList) {
      for (let i = 0; i < nodeList.length; i++) {
        if (target === nodeList[i]) {
          return i;
        }
      }
    },
    bmidfwtxt(id, data) {
      this.radiobmid = data;
      console.log(data);
    },
    validateForm(id) {
      this.$refs["addForm"].validate((valid) => {
        valid && this.add(id);
      });
    },
    add(id) {
      var radio = this.addForm.radio;
      if (id == 1) {
        var data = {
          service: "Examination.ExamAdd",
          cid: this.regiid,
          model_name: this.addForm.title,
          scope: radio,
          userid: localStorage.getItem("userid"),
        };
        this.$axios.post(this.url, this.$qs.stringify(data)).then((res) => {
          if (res.data.data.code == 0) {
            this.alertView.successView(res.data.data.msg);
            this.dialogAdd = false;

            this.reload();
          } else {
            this.alertView.failView(res.data.data.msg);
          }
        });
      } else {
        var data = {
          service: "Examination.Examupd",
          cid: this.regiid,
          model_name: this.addForm.title,
          eid: this.editEid,
          scope: radio,
          userid: localStorage.getItem("userid"),
        };
        this.$axios.post(this.url, this.$qs.stringify(data)).then((res) => {
          if (res.data.data.code == 0) {
            this.alertView.successView(res.data.data.msg);
            this.dialogAdd = false;
            this.reload();
          } else {
            this.alertView.failView(res.data.data.msg);
          }
        });
      }
    },
    del(i, id) {
      var btn = document.getElementsByClassName("exam_delbtn");
      const h = this.$createElement;
      var data = {
        service: "Examination.Examdel",
        eid: id,
        userid: localStorage.getItem("userid"),
      };
      this.$msgbox({
        title: "消息",
        message: h("p", null, [h("span", null, "是否确定删除")]),
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        lockScroll: false,
        showClose: false,
        customClass: "delBtn",
      }).then((action) => {
        this.$axios.post(this.url, this.$qs.stringify(data)).then((res) => {
          if (res.data.data.code == 0) {
            this.tableData.splice(i, 1);
            this.alertView.successView(res.data.data.msg);
          } else {
            this.alertView.failView(res.data.data.msg);
          }
        });
      });
    },

    typeView(e) {
      if (e == 2) {
        this.visible = true;
        this.bmid = 3;
      } else {
        this.visible = false;
      }
    },
    hrefto(id) {
      let data = {
        service: "Index.Check_Auth",
        user_id: localStorage.getItem("userid"),
        auth_root: "Examination.ExamInfo",
      };
      checkindex(this.HOME, data).then((res) => {
        if (res.data.data.code == "405") {
          this.alertView.failView(res.data.data.msg);
          return false;
        }
        this.$router.push({ path: "/detail/", query: { id: id } });
      });
    },
    pagetion(limit, page) {
      let val = this.$refs["cascader"].getCheckedNodes();
      val.length > 0 ? (this.cateid = val[0].data.c_id) : (this.cateid = 0);
      var data = {
        service: "Examination.ExamList",
        limit: limit,
        page: page,
        cate: this.cateid,
        where: this.input,
      };
      var List = [];
      var url = this.url;
      this.page = page;
      this.$axios
        .post(url, this.$qs.stringify(data))
        .then((res) => {
          if (res.data.data.code == 0) {
            this.count = parseInt(res.data.data.info.count);
            for (let i = 0; i < res.data.data.info.list.length; i++) {
              List.push(res.data.data.info.list[i]);
            }
            this.tableData = List;
          } else {
          }
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    chageMe(e) {
      var List = [];
      var count = 0;
      this.cascaderVal = "";
      this.input = "";
      if (e == true) {
        var data = {
          service: "Examination.ExamMyqsn",
          userid: localStorage.getItem("userid"),
        };
        this.$axios
          .post(this.HOME, this.$qs.stringify(data))
          .then((res) => {
            if (res.data.data.code == 0) {
              this.count = parseInt(res.data.data.info.count);
              for (let i = 0; i < res.data.data.info.length; i++) {
                List.push(res.data.data.info[i]);
              }
            } else {
              this.alertView.failView("目前没有自己创建的题库");
            }
            this.tableData = List;
            this.count = parseInt(res.data.data.count);
          })
          .catch(function (error) {
            // 请求失败处理
            console.log(error);
          });

        this.count = count;
      } else {
        this.pagetion(this.limit, this.page);
      }
    },
    searchtxt() {
      var list = [];
      this.checked = "";
      this.tableData = [];
      this.cascaderVal = "";
      let that = this;
      new Promise(function (resolve, reject) {
        that.comview.search(
          that.HOME,
          { service: "Examination.ExamList", where: that.input },
          function (res, Message) {
            resolve(res);
          }
        );
      }).then(function (res) {
        if (res.data.data.info.list.length !== 0) {
          for (var i = 0; i < res.data.data.info.list.length; i++) {
            list.push(res.data.data.info.list[i]);
          }
        } else {
          that.alertView.failView("没有搜索到该试题");
        }
        that.count = parseInt(res.data.data.info.count);
        that.tableData = list;
      });
    },
    dialogAdditem(id, eid) {
      this.dialogAdd = true;
      var data = [];
      this.$axios
        .post(
          this.HOME,
          this.$qs.stringify({
            service: "Cate.Cateinfo",
            userid: localStorage.getItem("userid"),
          })
        )
        .then((res) => {
          for (var i = 0; i < res.data.data.length; i++) {
            data.push(res.data.data[i]);
          }
          this.viewList = data;
        });
      if (id == 1) {
        this.addForm.title = "";
        this.addForm.region = "";
        this.addForm.radio = "1";
        this.editExam = 1;
      } else {
        this.editEid = eid.row.e_id;
        this.editExam = 2;
        var dataEdit = {
          service: "Examination.Examedit",
          eid: eid.row.e_id,
        };
        this.$axios
          .post(this.HOME, this.$qs.stringify(dataEdit))
          .then((res) => {
            this.addForm.title = res.data.data[0].model_name;
            this.addForm.region = res.data.data[0].name;
            this.regiid = res.data.data[0].c_id;
            this.addForm.radio = res.data.data[0].scope;
            // if(res.data.data[0].scope!='1' || res.data.data[0].scope!='3'){
            //   this.addForm.radio = '2'
            // }
            // else{
            // }
          });
      }
    },
    nodeclick(node, data, vuecomponent) {
      let res = data.childNodes.length;
      if (res == 0) {
        this.addForm.region = data.label;
        this.regiid = data.data.c_id;
        $(".el-dialog .el-input").eq(0).trigger("click");
      }
    },
    editview() {
      this.visible = true;
      this.bmid = 3;
    },
    cascaderOp() {
      let val = this.$refs["cascader"].getCheckedNodes();
      this.checked = "";
      this.input = "";
      if (this.cascaderVal != "") {
        let id = val[0].data.c_id;
        var data = {
          service: "Examination.ExamList",
          cate: id,
        };
        this.page = 1;
        var List = [];
        this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
          if (res.data.data.code == 0) {
            this.count = parseInt(res.data.data.info.count);
            for (let i = 0; i < res.data.data.info.list.length; i++) {
              List.push(res.data.data.info.list[i]);
            }
          }
          this.tableData = List;
        });
      } else {
        this.pagetion(this.limit, this.page);
      }
    },
  },

  mounted() {
    var data = [];
    console.log(this.HOME);
    this.pagetion(this.limit, this.page);
    // var ldata = {
    //   url_list:
    //     "https://cs.17zwd.com/item.htm?GID=117418027&spm=0.48.0.517944.117418027.0.0&action=2&so=%E6%89%8B%E6%9C%BA",
    // };
    // this.$axios
    //   .post("http://47.119.155.69:8777/", this.$qs.stringify(ldata))
    //   .then((res) => {});
    this.$axios
      .post(
        this.HOME,
        this.$qs.stringify({
          service: "Cate.Cateinfo",
          userid: localStorage.getItem("userid"),
        })
      )
      .then((res) => {
        if (res.data.data.code == 405) {
          this.alertView.failView(res.data.data.msg);
          this.$router.go(-1);
          return false;
        }
        for (var i = 0; i < res.data.data.length; i++) {
          data.push(res.data.data[i]);
        }
        this.options = data;
      });
  },
};
</script>

<style>
@import "../assets/css/examManeger.css";
</style>



// WEBPACK FOOTER //
// src/components/index.vue